import {
  getAdventureStyle,
  putAdventureStyle,
} from "@/common/adventure/AdventureStyle";
import { DesignProfileStore } from "../character/details";

export interface designState {
  id: number;
  pageBackground: string;
  textShade1: string;
  textShade2: string;
  componentBacking: string;
  inputBacking: string;
  alertShade: string;
  font: string;
  pictoral: boolean;
  overrideCharacterColorScheme: boolean;
}
export default {
  namespaced: true,
  state: (): designState => ({
    id: 0,
    pageBackground: "#dfdfdf",
    textShade1: "#dfdfdf",
    textShade2: "#000000",
    componentBacking: "#422c58",
    inputBacking: "#f1eef1",
    alertShade: "#c15be6",
    font: "Bahnschrift",
    pictoral: true,
    overrideCharacterColorScheme: true,
  }),
  getters: {
    pageBackground: (state: designState) => {
      return state.pageBackground;
    },
    textShade1: (state: designState) => {
      return state.textShade1;
    },
    testShade2: (state: designState) => {
      return state.textShade2;
    },
    componentBacking: (state: designState) => {
      return state.componentBacking;
    },
    inputBacking: (state: designState) => {
      return state.inputBacking;
    },
    alertShade: (state: designState) => {
      return state.alertShade;
    },
    font: (state: designState) => {
      return state.font;
    },
    overrideCharacterColorScheme: (state: designState) => {
      return state.overrideCharacterColorScheme;
    },
  },
  mutations: {
    setDesignState: (state: designState, newData: designState) => {
      if (newData) {
        state.id = newData.id;
        state.pageBackground = newData.pageBackground;
        state.textShade1 = newData.textShade1;
        state.textShade2 = newData.textShade2;
        state.componentBacking = newData.componentBacking;
        state.inputBacking = newData.inputBacking;
        state.alertShade = newData.alertShade;
        state.font = newData.font;
      }
    },
    setAdventureDesignState: (state: designState, newData: designState) => {
      state.pageBackground = newData.pageBackground;
      state.textShade1 = newData.textShade1;
      state.textShade2 = newData.textShade2;
      state.componentBacking = newData.componentBacking;
      state.inputBacking = newData.inputBacking;
      state.alertShade = newData.alertShade;
      state.font = newData.font;
    },
  },
  actions: {
    pullDesign: (context: any, id: number) => {
      getAdventureStyle(id).then((response) => {
        context.commit("setDesignState", response.data[0]);
      });
    },
    updateDesign: (context: any, newData: designState) => {
      putAdventureStyle(newData);
      context.commit("setDesignState", newData);
    },
  },
};
